import {useQuery} from '@tanstack/react-query'
import {queryKeys} from '../../constants/queryKey'
import {getComplainTypeItemsWithPlaceManageId} from '../../api/selects'

function useGetComplainTypeItemsQuery(placeManageId: string | null) {
  return useQuery([queryKeys.selects], () => getComplainTypeItemsWithPlaceManageId(placeManageId))
}

export default useGetComplainTypeItemsQuery
